// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-pages-HR-HRSettings-PeopleTableEditor-___PeopleTableEditor-module__container {
  display: flex;
  padding: 5px;
  height: 100%;
}

.app-pages-HR-HRSettings-PeopleTableEditor-___PeopleTableEditor-module__rightContainer {
  flex: 5 1 auto;
  display: flex;
  flex-direction: column;
}

.app-pages-HR-HRSettings-PeopleTableEditor-___PeopleTableEditor-module__leftContainer {
  padding: 5px;
  height: 100%;
  overflow-y: auto;
  min-width: 600px;
}

.app-pages-HR-HRSettings-PeopleTableEditor-___PeopleTableEditor-module__AttributesBlockContainer {
  max-width: 100%;
  width: 100%;
}

.app-pages-HR-HRSettings-PeopleTableEditor-___PeopleTableEditor-module__tableNameContainer {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: nowrap;
  padding: 15px;
  height: 55px;
}

.app-pages-HR-HRSettings-PeopleTableEditor-___PeopleTableEditor-module__tableNameContainer {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: nowrap;
  padding: 15px;
  height: 55px;
  position: sticky;
  top: 0;
  background-color: #ffffff;
  z-index: 10;
}

.app-pages-HR-HRSettings-PeopleTableEditor-___PeopleTableEditor-module__tableTitle {
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  flex-wrap: nowrap;
  font-weight: bold;
  font-size: 20px;
  line-height: 20px;
  height: 55px;
  position: sticky;
  top: 0;
  background-color: #ffffff;
  z-index: 10;
}

.app-pages-HR-HRSettings-PeopleTableEditor-___PeopleTableEditor-module__tableTitle:hover > .app-pages-HR-HRSettings-PeopleTableEditor-___PeopleTableEditor-module__viewTableButton {
    opacity: 0.5;
  }

.app-pages-HR-HRSettings-PeopleTableEditor-___PeopleTableEditor-module__viewTableButton {
  cursor: pointer;
  opacity: 0.3;
  padding-left: 6px;
  font-size: 18px;
}

.app-pages-HR-HRSettings-PeopleTableEditor-___PeopleTableEditor-module__viewTableButton:hover {
    opacity: 1 !important;
  }
`, "",{"version":3,"sources":["webpack://./app/pages/HR/HRSettings/PeopleTableEditor/PeopleTableEditor.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,MAAM;EACN,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,MAAM;EACN,yBAAyB;EACzB,WAAW;AAKb;;AAHE;IACE,YAAY;EACd;;AAGF;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,eAAe;AAKjB;;AAHE;IACE,qBAAqB;EACvB","sourcesContent":[".container {\n  display: flex;\n  padding: 5px;\n  height: 100%;\n}\n\n.rightContainer {\n  flex: 5 1 auto;\n  display: flex;\n  flex-direction: column;\n}\n\n.leftContainer {\n  padding: 5px;\n  height: 100%;\n  overflow-y: auto;\n  min-width: 600px;\n}\n\n.AttributesBlockContainer {\n  max-width: 100%;\n  width: 100%;\n}\n\n.tableNameContainer {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  flex-wrap: nowrap;\n  padding: 15px;\n  height: 55px;\n}\n\n.tableNameContainer {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  flex-wrap: nowrap;\n  padding: 15px;\n  height: 55px;\n  position: sticky;\n  top: 0;\n  background-color: #ffffff;\n  z-index: 10;\n}\n\n.tableTitle {\n  display: flex;\n  flex-direction: row;\n  align-content: center;\n  align-items: center;\n  flex-wrap: nowrap;\n  font-weight: bold;\n  font-size: 20px;\n  line-height: 20px;\n  height: 55px;\n  position: sticky;\n  top: 0;\n  background-color: #ffffff;\n  z-index: 10;\n\n  &:hover > .viewTableButton {\n    opacity: 0.5;\n  }\n}\n\n.viewTableButton {\n  cursor: pointer;\n  opacity: 0.3;\n  padding-left: 6px;\n  font-size: 18px;\n\n  &:hover {\n    opacity: 1 !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `app-pages-HR-HRSettings-PeopleTableEditor-___PeopleTableEditor-module__container`,
	"rightContainer": `app-pages-HR-HRSettings-PeopleTableEditor-___PeopleTableEditor-module__rightContainer`,
	"leftContainer": `app-pages-HR-HRSettings-PeopleTableEditor-___PeopleTableEditor-module__leftContainer`,
	"AttributesBlockContainer": `app-pages-HR-HRSettings-PeopleTableEditor-___PeopleTableEditor-module__AttributesBlockContainer`,
	"tableNameContainer": `app-pages-HR-HRSettings-PeopleTableEditor-___PeopleTableEditor-module__tableNameContainer`,
	"tableTitle": `app-pages-HR-HRSettings-PeopleTableEditor-___PeopleTableEditor-module__tableTitle`,
	"viewTableButton": `app-pages-HR-HRSettings-PeopleTableEditor-___PeopleTableEditor-module__viewTableButton`
};
export default ___CSS_LOADER_EXPORT___;
